module.exports = __webpack_public_path__ + "3eac4a6943cd0a043575503ec4620a6b.png";